import * as React from 'react';
import * as utils from '../common/hex-converter';
import styles from './slider-rating.scss';

export interface SlidingBarProps {
  bars: any[];
  active: number;
  isRtl?: boolean;
}

export class SlidingBar extends React.Component<SlidingBarProps, any> {

  private renderItem = (index: number, color: number) => {
    let colorOfValue = {};

    /**
     * Bar display differs depending if `backgroundColour` has been received
     * from backend - we override the CSS with inline
     */

    if (color) {
      const convertedColor = utils.toHex(color);
      colorOfValue = { background: `${convertedColor} ` };
    }
    const classes = [styles.barSegment];
    if (index < this.props.active) {
      classes.push(styles.line);
    }
    if (index === this.props.active) {
      classes.push(styles.active);
    }

    return <div
      className={classes.join(' ')}
      style={colorOfValue}
      key={index}
    />;
  };

  public render() {
    const {bars, isRtl} = this.props;
    const rtlStyle = isRtl && styles.barBoxReverse;

    return !!bars?.length ? (
        <div className={`${styles.barBox} ${rtlStyle}`}>
          {bars.map((item, index) => this.renderItem(index, item.backgroundColor))}
        </div>
    ) : null;
  }
}
